import zodiacSignsList from './actions/zodiacSignsList';
import getZodiacSigns from './getters/getZodiacSigns';
import zodiacSignsUpload from './mutations/zodiacSignsUpload';

const actions = {
    zodiacSignsList
};

const mutations = {
    zodiacSignsUpload
};

const getters = {
    getZodiacSigns
};

export default { actions, mutations, getters };
